import React from 'react';
import { TableHeader, TableRow, TableHeaderColumn, Table, TableRowColumn, TableBody, Dialog, FlatButton } from 'material-ui';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import api from 'services';
import { showNotification } from 'helpers';

import EditAddDialog from './EditAddDialog';

const defaultStyles = { 
    textAlign: 'center',
    padding: 0,
};

const styles = {
    longText: {
        ...defaultStyles,
        width: '120px',
    },
    middleText: {
        ...defaultStyles,
        width: '80px',
    },
    smallText: {
        ...defaultStyles,
        width: '65px',
    },

};

const initialPdaEditAddState = {
    _id: '',
    approved: true,
    averagePortCostsUsdDay: null,
    param: {
        country: {},
        port: {},
        vessel: {},
        dwt: '',
        ourGroup: '',
    },
}; 

const initialPdaDeleteState = {
    _id: '',
};

class PdaTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openDeleteDialog: false,
            openEditDialog: false,
            vessels: [],
            ports: [],
            pdaEditAdd: Object.assign({}, initialPdaEditAddState),
            pdaDelete: Object.assign({}, initialPdaDeleteState),
        };
    }

    handleCloseDialog = (type) => {
        let fields = {};

        switch (type) {
        case 'edit':
            fields = {
                dialog: 'openEditDialog',
                init: Object.assign({}, initialPdaEditAddState),
                state: 'pdaEditAdd',
            };
            break;
        case 'delete': 
            fields = {
                dialog: 'openDeleteDialog',
                init: Object.assign({}, initialPdaDeleteState),
                state: 'rateDelete',
            };
            break;
        case 'add':
            this.props.handleOpenAddDialog();
            this.setState({
                pdaEditAdd: Object.assign({}, initialPdaEditAddState),
            });
            return;
        }
        
        this.setState({
            [fields.dialog]: false,
            [fields.state]: fields.init,
        });
    }

    handleOpenDelete = (_id) => {
        this.setState({
            pdaDelete: { _id },
            openDeleteDialog: true,
        });
    }

    handlePdaDelete = async () => {
        const res = await api.pdaDelete(this.state.pdaDelete._id);

        if (res.status === 200) {
            this.setState({
                openDeleteDialog: false,
                pdaDelete: Object.assign({}, initialPdaDeleteState),
            });
            showNotification('PDA deleted', 'success');
        } else {
            showNotification(res.errors[0].messages[0], 'error');
        }
        this.props.handleFilter();
    }

    handleOpenEdit = (pdaEditAdd) => {
        this.setState({
            pdaEditAdd,
            openEditDialog: true,
        });
    }

    handleSelectCountry = (e, i) => {
        e.preventDefault();
        if (i === 0) {
            this.updateEditAddState('country', { value: { name: '', _id: '' } });
            return;
        }

        const { _id, name } = this.props.countries[i];

        this.updateEditAddState('country', { value: { name, _id } });
    }

    updateEditAddState = (type, data, cb) => {
        if (!data.hasOwnProperty('value')) {
            this.setState({
                pdaEditAdd: {
                    ...this.state.pdaEditAdd,
                    [type]: data,
                },
            }, cb);
        } else {
            this.setState({
                pdaEditAdd: {
                    ...this.state.pdaEditAdd,
                    param: {
                        ...this.state.pdaEditAdd.param,
                        [type]: data.value,
                    },
                },
            }, cb);
        }
    }

    changeVesselAutoComplete = (searchVessel) => {
        this.updateEditAddState('vessel', { value: { _id: this.state.pdaEditAdd.param.vessel._id, name: searchVessel } }, () => {
            if (!searchVessel) {
                this.updateEditAddState('vessel', { value: { _id: '', name: searchVessel } });
            } 
            if (searchVessel.length < 2) {
                return;
            }

            api.findVessel(searchVessel)
                .then((response) => {
                    const vessels = response.data.data.map(vessel => ({
                        name: `${vessel.name} (${vessel.imoNumber})`,
                        item: vessel,
                    }));
    
                    this.setState({
                        vessels,
                    });
                })
                .catch((e) => {
                    showNotification(e, 'error');
                });
        });
    }

    chooseVesselAutoComplete = ({ name, item: { _id, imoNumber } }) => {
        this.updateEditAddState('vessel', { value: { _id, name, imoNumber } });
    }

    handleSelectVesselType = (e) => {
        e.preventDefault();
        this.updateEditAddState('ourGroup', { value: e.target.innerText });
    }

    handleChangeDwt = (e) => {
        e.preventDefault();
        this.updateEditAddState('dwt', { value: e.target.value });
    }

    handleChangePda = (e) => {
        e.preventDefault();
        this.updateEditAddState('averagePortCostsUsdDay', parseInt(e.target.value).toFixed());
    }

    changePortName = (searchPort) => {
        this.updateEditAddState('port', { value: { _id: this.state.pdaEditAdd.param.port._id, name: searchPort } }, () => {
            if (!searchPort) {
                this.updateEditAddState('port', { value: { _id: '', name: searchPort } });
            } 
            if (searchPort.length < 2) {
                return;
            }

            api.findPortAdmin({ name: searchPort })
                .then((response) => {
                    const ports = response.data.data.map(port => ({
                        name: `${port.name}`,
                        item: port,
                    }));
    
                    this.setState({
                        ports,
                    });
                })
                .catch((e) => {
                    showNotification(e, 'error');
                });
        });
    }

    choosePort = ({ name, item: { _id } }) => {
        this.updateEditAddState('port', { value: { _id, name } });
    }

    handleCheckConfirmed = () => {
        this.updateEditAddState('approved', !this.state.pdaEditAdd.approved);
    }

    handleRateEditAdd = async (type) => {
        const {
            _id, averagePortCostsUsdDay, approved, param: {
                country, port, vessel, dwt, ourGroup, 
            }, 
        } = this.state.pdaEditAdd;

        if (!parseInt(averagePortCostsUsdDay) || !country._id || !port._id || !vessel._id || !parseInt(dwt) || !ourGroup) {
            showNotification('Specify all required fields', 'error');
            return;
        }

        const body = {
            _id,
            averagePortCostsUsdDay: parseInt(averagePortCostsUsdDay),
            approved,
            param: {
                portID: port._id,
                countryID: country._id,
                dwt,
                ourGroup,
                vesselId: vessel._id,
            },
        };

        let response;

        if (type === 'edit') {
            response = await api.pdaUpdate(body);
        } else {
            response = await api.pdaAdd(body);
        }

        if (response.status !== 200) {
            showNotification(response.errors[0].messages[0], 'error');
            return;
        }

        type === 'add' && this.props.handleOpenAddDialog();
        this.setState({
            openEditDialog: false,
            pdaEditAdd: Object.assign({}, initialPdaEditAddState),
        }, async () => {
            showNotification(`PDA ${type === 'add' ? 'created' : 'modified'}`, 'success');
            await this.props.handleFilter();
        });
    }

    render() {
        const {
            pdas, countries, openAddDialog, handleOpenAddDialog, vesselTypes, shouldShowConfirmCheckbox, 
        } = this.props;
        const {
            openDeleteDialog, openEditDialog, vessels, ports, pdaEditAdd, 
        } = this.state;
        
        const deleteActions = [
            <FlatButton
                label="Cancel"
                primary
                onClick={() => this.handleCloseDialog('delete')}
            />,
            <FlatButton
                label="Delete"
                primary
                keyboardFocused
                onClick={this.handlePdaDelete}
            />,
        ];
        return (
            <div>
                <EditAddDialog
                    openAddDialog={openAddDialog}
                    openEditDialog={openEditDialog}
                    countries={countries}
                    handleCloseDialog={this.handleCloseDialog}
                    handleSelectCountry={this.handleSelectCountry}
                    handleOpenAddDialog={handleOpenAddDialog}
                    vesselTypes={vesselTypes}
                    vessels={vessels}
                    ports={ports}
                    pdaEditAdd={pdaEditAdd}
                    changeVesselAutoComplete={this.changeVesselAutoComplete}
                    chooseVesselAutoComplete={this.chooseVesselAutoComplete}
                    handleSelectVesselType={this.handleSelectVesselType}
                    handleChangeDwt={this.handleChangeDwt}
                    handleChangePda={this.handleChangePda}
                    changePortName={this.changePortName}
                    choosePort={this.choosePort}
                    handleCheckConfirmed={this.handleCheckConfirmed}
                    handleRateEditAdd={this.handleRateEditAdd}
                    shouldShowConfirmCheckbox={shouldShowConfirmCheckbox}
                />
                <Dialog
                    title='Delete rate'
                    open={openDeleteDialog}
                    actions={deleteActions}
                    onRequestClose={() => this.handleCloseDialog('delete')}
                >
                    Are you sure you want to delete pda?
                </Dialog>
                <Table>
                    <TableHeader
                        displaySelectAll={false}
                        enableSelectAll={false}
                        adjustForCheckbox={false}
                    >
                        <TableRow>
                            <TableHeaderColumn style={styles.longText}>Vessel</TableHeaderColumn>
                            <TableHeaderColumn style={styles.middleText}>Vessel Type</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>DWT</TableHeaderColumn>
                            <TableHeaderColumn style={styles.longText}>Port</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText}>P D/A</TableHeaderColumn>
                            <TableHeaderColumn style={styles.middleText}>Country</TableHeaderColumn>
                            <TableHeaderColumn style={styles.smallText} />
                        </TableRow>
                    </TableHeader>
                    <TableBody
                        displayRowCheckbox={false}
                    >
                        {
                            pdas && pdas.map((item, index) => {
                                const {
                                    averagePortCostsUsdDay, param: {
                                        country, dwt, ourGroup, port, vessel, 
                                    }, 
                                } = item;

                                if (vessel.imoNumber && !vessel.name.includes(' (')) {
                                    vessel.name = `${vessel.name} (${vessel.imoNumber})`;
                                }

                                return (
                                    <TableRow
                                        key={item._id}
                                        displayBorder
                                        selectable={false}
                                        hoverable
                                    >
                                        <TableRowColumn style={styles.longText}>{vessel.name}</TableRowColumn>
                                        <TableRowColumn style={styles.middleText}>{ourGroup}</TableRowColumn>
                                        <TableRowColumn style={styles.smallText}>{dwt}</TableRowColumn>
                                        <TableRowColumn style={styles.longText}>{port.name}</TableRowColumn>
                                        <TableRowColumn style={styles.smallText}>{averagePortCostsUsdDay.toFixed()}</TableRowColumn>
                                        <TableRowColumn style={styles.middleText}>{country.name}</TableRowColumn>
                                        <TableRowColumn
                                            style={styles.smallText}
                                        >
                                            <EditIcon
                                                cursor='pointer'
                                                color='#09BCD4'
                                                onClick={() => this.handleOpenEdit(item)}
                                            />
                                            <DeleteIcon
                                                cursor='pointer'
                                                color='#FF4081'
                                                onClick={() => this.handleOpenDelete(item._id)}
                                            />
                                        </TableRowColumn>
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default PdaTable;



// WEBPACK FOOTER //
// ./app/components/Prices/Pda/PdaTable.jsx